import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";

const NAV = [
    { label: "Work", href: "/work", route: true },
    { label: "Services", href: "/#services" },
    { label: "Team", href: "/team", route: true },
    { label: "Studio", href: "/#about" },
    { label: "Contact", href: "/#contact" },
];

export const Header = ({ onQuote, onMeeting }) => {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-header"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
                scrolled
                    ? "bg-[#FAF9F6]/92 backdrop-blur-md border-b border-[#1A1A1A]/10"
                    : "bg-transparent"
            }`}
        >
            <div className="max-w-[1500px] mx-auto px-6 md:px-12 lg:px-16 flex items-center justify-between py-3 md:py-4">
                <Logo size={96} />

                <nav className="hidden lg:flex items-center gap-10">
                    {NAV.map((n) =>
                        n.route ? (
                            <Link
                                key={n.href}
                                to={n.href}
                                data-testid={`nav-${n.label.toLowerCase()}`}
                                className="dd-link overline text-[#1A1A1A]"
                            >
                                {n.label}
                            </Link>
                        ) : (
                            <a
                                key={n.href}
                                href={n.href}
                                data-testid={`nav-${n.label.toLowerCase()}`}
                                className="dd-link overline text-[#1A1A1A]"
                            >
                                {n.label}
                            </a>
                        )
                    )}
                </nav>

                <div className="hidden lg:flex items-center gap-3">
                    <button
                        data-testid="header-meeting-btn"
                        onClick={onMeeting}
                        className="btn-secondary"
                    >
                        Book Meeting
                    </button>
                    <button
                        data-testid="header-quote-btn"
                        onClick={onQuote}
                        className="btn-primary"
                    >
                        Get Quote
                    </button>
                </div>

                <button
                    data-testid="mobile-menu-toggle"
                    className="lg:hidden p-2"
                    onClick={() => setOpen((v) => !v)}
                    aria-label="Toggle menu"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>

            {/* Mobile menu */}
            {open && (
                <div className="lg:hidden border-t border-[#1A1A1A]/10 bg-[#FAF9F6]">
                    <div className="px-6 py-8 flex flex-col gap-6">
                        {NAV.map((n) =>
                            n.route ? (
                                <Link
                                    key={n.href}
                                    to={n.href}
                                    onClick={() => setOpen(false)}
                                    data-testid={`mobile-nav-${n.label.toLowerCase()}`}
                                    className="font-serif text-3xl text-[#1A1A1A]"
                                >
                                    {n.label}
                                </Link>
                            ) : (
                                <a
                                    key={n.href}
                                    href={n.href}
                                    onClick={() => setOpen(false)}
                                    data-testid={`mobile-nav-${n.label.toLowerCase()}`}
                                    className="font-serif text-3xl text-[#1A1A1A]"
                                >
                                    {n.label}
                                </a>
                            )
                        )}
                        <div className="flex flex-col gap-3 pt-4">
                            <button
                                data-testid="mobile-meeting-btn"
                                onClick={() => {
                                    setOpen(false);
                                    onMeeting();
                                }}
                                className="btn-secondary justify-center"
                            >
                                Book Meeting
                            </button>
                            <button
                                data-testid="mobile-quote-btn"
                                onClick={() => {
                                    setOpen(false);
                                    onQuote();
                                }}
                                className="btn-primary justify-center"
                            >
                                Get Quote
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </header>
    );
};
